// This file was auto-generated by Fern from our API Definition.
import * as core from "../core/index.js";
import * as errors from "../errors/index.js";
const PARAM_KEY = "apiKey";
const HEADER_NAME = "Authorization";
export class HeaderAuthProvider {
    options;
    constructor(options) {
        this.options = options;
    }
    static canCreate(options) {
        return options?.[PARAM_KEY] != null;
    }
    async getAuthRequest({ endpointMetadata, } = {}) {
        const headerValue = await core.Supplier.get(this.options[PARAM_KEY]);
        if (headerValue == null) {
            throw new errors.AgentaApiError({
                message: HeaderAuthProvider.AUTH_CONFIG_ERROR_MESSAGE,
            });
        }
        return {
            headers: { [HEADER_NAME]: headerValue },
        };
    }
}
(function (HeaderAuthProvider) {
    HeaderAuthProvider.AUTH_SCHEME = "APIKeyHeader";
    HeaderAuthProvider.AUTH_CONFIG_ERROR_MESSAGE = `Please provide '${PARAM_KEY}' when initializing the client`;
    function createInstance(options) {
        return new HeaderAuthProvider(options);
    }
    HeaderAuthProvider.createInstance = createInstance;
})(HeaderAuthProvider || (HeaderAuthProvider = {}));
